import React, { useState } from 'react';
import logo from '../../../assets/marketing/Jane Rothe/janeRotheLogoBlack.webp';
import { Link, useLocation } from 'react-router-dom';
import { PopupButton } from 'react-calendly';
import { CONTACT_US_CALENDLY_URL } from '../../../utils/constant/constants';

const Header = () => {
	const location = useLocation();
	const pathname = location?.pathname;
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

	const toggleMobileMenu = () => {
		setIsMobileMenuOpen((prevState) => !prevState);
	};

	const RouteData = [
		{ name: 'Services', route: '/services' },
		{ name: 'About us', route: '/about-us' },
		{ name: 'Book a Call', route: '/contact' },
		{ name: 'Sign In', route: '/login' },
		// { name: 'Blog', route: '/blog' },
	];

	return (
		<div className='bg-white w-full fixed z-50 shadow-sm border-b border-gray-100'>
			<header className='font-body bg-white text-clientNero h-[80px]  mx-auto px-6 tablet:px-0 mobile:px-0'>
				<div className='flex justify-between items-center h-full tablet:px-[20px] mobile:px-[20px]'>
					<Link to='/' className='flex items-center'>
						<img
							className='h-16 w-auto sm:h-20'
							alt='Janerothe Logo'
							src={logo}
						/>
					</Link>

					<nav className='ml-5'>
						<ul className='mobile:hidden tablet:hidden flex space-x-6 items-center'>
							{RouteData.map((item, index) =>
								item.route === '/contact' ? (
									<li key={index}>
										<PopupButton
											url='https://calendly.com/amy-janerothe/15-min-results-call'
											rootElement={document.getElementById('root')}
											text='Book a Call'
											className='bg-primary text-white px-6 py-2 rounded font-montserrat-medium text-[14px] uppercase hover:bg-opacity-90 transition-all'
										/>
									</li>
								) : item.route === '/login' ? (
									<li key={index}>
										<Link
											to={item.route}
											className='border-2 border-clientBlack text-clientBlack px-6 py-2 rounded font-montserrat-medium text-[14px] uppercase hover:bg-clientBlack hover:text-white transition-all'>
											{item.name}
										</Link>
									</li>
								) : (
									<li key={index}>
										<Link
											to={item.route}
											style={{
												color: pathname === item.route ? '#CC1DB9' : '#202020',
											}}
											className='body-regular'>
											{item.name}
										</Link>
									</li>
								)
							)}
						</ul>

						<div className='hidden mobile:block tablet:block'>
							<button
								onClick={toggleMobileMenu}
								className='text-gray-800 focus:outline-none pr-[5px]'>
								<svg
									className='w-6 h-6'
									fill='none'
									stroke='currentColor'
									viewBox='0 0 24 24'
									xmlns='http://www.w3.org/2000/svg'>
									<path
										strokeLinecap='round'
										strokeLinejoin='round'
										strokeWidth='2'
										d='M4 6h16M4 12h16M4 18h16'></path>
								</svg>
							</button>
						</div>
					</nav>
				</div>

				{isMobileMenuOpen && (
					<div className='hidden tablet:block mobile:block'>
						<ul className='flex flex-col space-y-2 p-4 bg-white shadow-md'>
							{RouteData.map((item, index) =>
								item.route === '/contact' ? (
									<li key={index}>
										<PopupButton
											url='https://calendly.com/amy-janerothe/15-min-results-call'
											rootElement={document.getElementById('root')}
											text='Book a Call'
											className='bg-primary text-white px-6 py-2 rounded font-montserrat-medium text-[14px] uppercase hover:bg-opacity-90 transition-all text-center'
										/>
									</li>
								) : item.route === '/login' ? (
									<li key={index}>
										<Link
											to={item.route}
											className='border-2 border-clientBlack text-clientBlack px-6 py-2 rounded font-montserrat-medium text-[14px] uppercase hover:bg-clientBlack hover:text-white transition-all text-center block'>
											{item.name}
										</Link>
									</li>
								) : (
									<li key={index}>
										<Link
											to={item?.route}
											style={{
												color: pathname === item.route ? '#CC1DB9' : '#202020',
											}}
											className='body-regular'>
											{item.name}
										</Link>
									</li>
								)
							)}
						</ul>
					</div>
				)}
			</header>
		</div>
	);
};

export default Header;
